<div class="w-full max-w-full mx-auto sm:max-w-[80%] mb-12 sm:mb-0">
  <div class="w-full max-w-full mx-auto sm:max-w-3/4">
    <div class="mb-6 text-left">
      <header class="mb-6">
        <div class="text-3xl font-bold">{{ title }}</div>
        @if (subtitle !== '') {
          <div class="mt-2 leading-tight text-secondary">{{ subtitle }}</div>
        }
      </header>
      <div class="flex flex-col w-full gap-4">
        <div bp-card class="flex flex-col gap-5">
          <!-- <span bp-title-card>Asignación Acciones - Renta Fija</span> -->

          <div class="flex flex-col gap-3">
            <div class="flex justify-between">
              <span>Nivel de riesgo</span>
              <div class="flex gap-2">
                @if (
                  riskLevelRecommended &&
                  riskLevelRecommended.position === currentRiskLevel?.position
                ) {
                  <span @fadeIn bp-tag>Recomendado</span>
                }
                <span class="font-medium">{{ currentRiskLevel?.title }}</span>
              </div>
            </div>
            <form [formGroup]="form" class="flex w-full">
              <div class="flex items-center w-full gap-1">
                <button
                  mat-icon-button
                  (click)="decreaseLevel()"
                  class="z-99"
                  [disabled]="currentRiskLevel?.position === 1"
                >
                  <mat-icon
                    color="primary"
                    [svgIcon]="'heroicons_outline:minus-circle'"
                    class="icon-size-5"
                  ></mat-icon>
                </button>
                <mat-slider min="1" [max]="riskLevels.length" step="1" class="w-full mx-0">
                  <input
                    formControlName="riskLevel"
                    matSliderThumb
                    id="cg-new-riskLevelSelection-riskLevel-slider"
                    [attr.data-cy]="'cg-new-riskLevelSelection-riskLevel-slider'"
                  />
                </mat-slider>

                <button
                  mat-icon-button
                  (click)="increaseLevel()"
                  class="z-99"
                  [disabled]="currentRiskLevel?.position === riskLevels.length"
                >
                  <mat-icon
                    color="primary"
                    [svgIcon]="'heroicons_outline:plus-circle'"
                    class="icon-size-5"
                  ></mat-icon>
                </button>
              </div>
            </form>

            @if (!riskLevelRecommended) {
              <article bp-callout>
                <p>
                  No podemos darte una recomendación para el nivel de riesgo de tu meta porque aún
                  no terminas de completar tu cuenta. Termina los primeros pasos
                  <span routerLink="/onboarding" bp-link>aquí</span>.
                </p>
              </article>
            }
            @if (!isLoading) {
              <div class="flex w-full gap-2" @fadeIn>
                <bp-bonds-stocks-graph
                  [bp-skeleton]="isLoading"
                  height="70px"
                  width="70px"
                  [showStroke]="true"
                  [showLabel]="false"
                  skeletonWidth="20"
                  skeletonHeight="20"
                  skeletonExtraClass="m-8"
                  [compositions]="compositions"
                >
                </bp-bonds-stocks-graph>

                <div class="flex flex-col">
                  <h1 bp-title-card class="capitalize">
                    {{ getCurrentCompositionLabel() }}
                  </h1>
                  @if (riskLevelRecommended) {
                    <span>
                      <p class="text align-items-center">
                        Te recomendamos un portafolio {{ riskLevelRecommended?.title | lowercase }}.
                        @if (currentRiskLevel?.position === riskLevelRecommended?.position) {
                          <span> Estás eligiendo un nivel de riesgo igual al recomendado. </span>
                        }
                        @if (currentRiskLevel?.position! > riskLevelRecommended?.position!) {
                          <span>
                            Estás eligiendo un nivel de riesgo más arriesgado que el recomendado.
                          </span>
                        }
                        @if (currentRiskLevel?.position! < riskLevelRecommended?.position!) {
                          <span>
                            Estás eligiendo un nivel de riesgo más conservador que el recomendado.
                          </span>
                        }
                      </p>
                    </span>
                  }
                </div>
              </div>
            }
          </div>
          <article bp-callout>
            <p>
              <span class="font-semibold">Importante:</span> Considera lo conversado con tu asesor y
              nunca elijas un nivel de riesgo que no te permita dormir tranquilo.
            </p>
          </article>
        </div>
        <div class="fixed bottom-0 left-0 z-50 w-full px-6 py-3 2-22 sm:p-0 sm:relative">
          <button
            mat-flat-button
            responsive-button-large
            [disabled]="isLoading"
            class="w-full"
            (click)="next.emit(currentRiskLevel)"
            color="primary"
            id="cg-new-riskLevelSelection-btn-continue"
            [attr.data-cy]="'cg-new-riskLevelSelection-btn-continue'"
          >
            Continuar
          </button>
        </div>

        @if (showFaqs) {
          <div class="mt-6">
            <app-blog-faqs
              [showTitle]="false"
              [legacyStyle]="true"
              [tabParent]="StateEnum.riskLevelSelection.toLowerCase()"
              [investmentStrategy]="'goals-new'"
            ></app-blog-faqs>
          </div>
        }
      </div>
    </div>
  </div>
</div>
